import { Navigate } from "react-router-dom";

export default function AdminRevenue() {
  return <Navigate to="/admin/cfo?tab=revenue-model" replace />;
}